import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  discipline: null,
};

export const DisciplineSlice = createSlice({
  name: "DisciplineSlice",
  initialState,
  reducers: {
    setDiscipline: (state, { payload }) => {
      state.discipline = payload;
      console.log(payload, "@all payload discipline");
    },

    setCreateDiscipline: (state, { payload }) => {
      state.discipline.disciplines = [...state.discipline.disciplines, payload];
    },

    setUpdateDiscipline: (state, { payload }) => {
      console.log(payload, "@Update payload discipline");
      state.discipline.disciplines = state.discipline.disciplines.map(
        (item) => {
          if (item._id === payload?._id) {
            return { ...item, ...payload };
          }
          return item;
        }
      );
    },

    setArchiveDiscipline: (state, { payload }) => {
      console.log(payload, "@archive payload discipline");
      const { _id } = payload;

      // Use map to update the 'archived' status for the corresponding item
      state.discipline.disciplines = state.discipline?.disciplines.map(
        (item) => {
          if (item._id === _id) {
            return { ...item, ...payload };
          }
          return item;
        }
      );
    },

    setDeleteDiscipline: (state, { payload }) => {
      console.log(payload, "@discipline delete payload");
      const updatedDiscipline = state.discipline?.disciplines?.filter(
        (discipline) => discipline._id !== payload._id
      );
      state.discipline.disciplines = updatedDiscipline;
    },
  },
});

export const {
  setDiscipline,
  setCreateDiscipline,
  setUpdateDiscipline,
  setArchiveDiscipline,
  setDeleteDiscipline,
} = DisciplineSlice.actions;
export default DisciplineSlice.reducer;
